function ColoredCircle({ color = '#E33B26', height = '16', width = '16', ...rest }) {
  return (
    <svg height={height} width={width} {...rest}>
      <circle cx="8" cy="8" r="6" fill={color} />
    </svg>
  );
}
export default ColoredCircle;
